import { useMemo } from 'react';

import {
  ContactGroupDetails,
  ManageEmailDomainsButton,
  MergeContactGroupsButton,
} from 'contacts/components/ContactGroupList';
import { ContactGroupType } from 'contacts/enums';
import { IContactGroup } from 'contacts/types';
import { AgGridServerTable } from 'core/components';
import { useAgGridTableContext } from 'core/states';

interface IProps {
  selectedContactGroup: IContactGroup | null;
  setSelectedContactGroup: (contactGroup: IContactGroup | null) => void;
}

export const VendorContactGroupListTable = ({
  selectedContactGroup,
  setSelectedContactGroup,
}: IProps) => {
  const { gridApi } = useAgGridTableContext();

  const onEditContactGroupSuccess = (contactGroup: IContactGroup) => {
    setSelectedContactGroup(contactGroup);
    gridApi?.refreshServerSide({ purge: true });
  };

  const selectionActionButtons = useMemo(() => {
    return [
      <ManageEmailDomainsButton key="addEmailDomainsButton" />,
      <MergeContactGroupsButton key="mergeContactGroupsButton" />,
    ];
  }, []);

  return (
    <>
      <AgGridServerTable selectionActionButtons={selectionActionButtons} />

      <ContactGroupDetails
        isOpen={!!selectedContactGroup}
        onClose={() => setSelectedContactGroup(null)}
        contactGroup={selectedContactGroup}
        contactGroupType={ContactGroupType.VENDOR}
        onEditContactGroupSuccess={onEditContactGroupSuccess}
      />
    </>
  );
};
